import { ActionMap } from 'action-typed';

export enum MetaEvents {
    STARTED_CHECKOUT = 'Meta.StartedCheckout',
    STARTED_CHECKOUT_ERROR = 'Meta.StartedCheckout.Error',
}

export enum MetaAnalyticEvents {
    STARTED_CHECKOUT = 'InitiateCheckout',
}

export enum MetaTagManagerEvents {
    STARTED_CHECKOUT = 'meta_started_checkout',
}

export type MetaCart = {
    cart_id?: string;
    cart_url?: string;
    delivery_type?: string;
    items_count?: number;
    items_qty?: number;
    total_value?: number;
};

export type MetaCustomer = {
    customer_email?: string;
    firstname?: string;
    is_guest?: boolean;
    lastname?: string;
};

export type MetaProduct = {
    content_id?: string;
    content_name?: string;
    content_category?: string;
    content_ids?: string[];
    contents?: {
        id: string;
        quantity: number;
        item_price?: number;
    }[];
    currency?: string;
    value?: number;
};

type MetaGtmEvent<TagManagerEvent extends MetaTagManagerEvents, MetaEvent extends MetaAnalyticEvents> = {
    cart_id?: string;
    event_name: MetaEvent;
    event: TagManagerEvent;
    session_id?: string;
    timestamp?: string;
    custom_data?: any;
};

export type MetaStartedCheckoutGtmEvent = MetaGtmEvent<
    MetaTagManagerEvents.STARTED_CHECKOUT,
    MetaAnalyticEvents.STARTED_CHECKOUT
> &
    MetaCustomer & {
        cart: MetaCart;
        checkout_id?: string;
        checkout_url?: string;
        content_ids: string[];
        contents: {
            id: string;
            quantity: number;
            item_price?: number;
        }[];
        currency: string;
        value: number;
        phone?: string;
    };

export type Messages = {
    [MetaEvents.STARTED_CHECKOUT]: MetaStartedCheckoutGtmEvent;
};

export type TypeMap = ActionMap<Messages>;
export type MetaActions = TypeMap[keyof TypeMap];
